import { render, staticRenderFns } from "./resultswrapper.vue?vue&type=template&id=713bf36c&scoped=true&"
import script from "./resultswrapper.vue?vue&type=script&lang=ts&"
export * from "./resultswrapper.vue?vue&type=script&lang=ts&"
import style0 from "./resultswrapper.vue?vue&type=style&index=0&id=713bf36c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713bf36c",
  null
  
)

export default component.exports